import React, {Component} from 'react';
import PropTypes from 'prop-types';

import './RobotHand.css';
import hand_up from './assets/arm/ARM_up_01.png';
import hand_mid from './assets/arm/ARM_mid_02.png';
import hand_down from './assets/arm/ARM_down_03.png';
import Timer from './Timer';

export default class RobotHand extends Component {
	constructor(props) {
		super(props);
		this.state = {
			src: props.is_clicking ? hand_down : hand_up,
		};
	}
	componentWillReceiveProps(new_props) {
		if (new_props.is_clicking === this.props.is_clicking) {
			return;
		}

		let new_src = null;
		if (new_props.is_clicking) {
			// hand is lowering
			switch (this.state.src) {
				case hand_up :
					new_src = hand_mid;
					break;
				case hand_mid :
					new_src = hand_down;
					break;
				default : 
					break;
			}
		}
		else {
			// hand is raising
			switch (this.state.src) {
				case hand_down :
					new_src = hand_mid;
					break;
				case hand_mid :
					new_src = hand_up;
					break;
				default : 
					break;
			}
		}
		if (new_src) {
			this.setState({src: new_src});
		}
	}
	render() {
		const {is_clicking} = this.props;
		const {src} = this.state;

		let timer = null;

		if (is_clicking && src === hand_mid) {
			timer = <Timer delay={100} on_timeout={() => this.setState({src: hand_down})} reset_prevention_key={'down'} />
		}
		else if (!is_clicking && src === hand_mid) {
			timer = <Timer delay={100} on_timeout={() => this.setState({src: hand_up})} reset_prevention_key={'up'} />
		}

		return <div>
			{timer}
			<img src={src} className="RobotHand" alt="Helping hand"/>
		</div>
	}
}
RobotHand.propTypes = {
	is_clicking: PropTypes.bool,
}


// WEBPACK FOOTER //
// ./src/RobotHand.js